import { useState, useEffect, useRef, useLayoutEffect } from "react";
import Header from "../components/shared/header";
import { useParams, useNavigate } from "react-router-dom";
import { axiosPrivate } from "../api/axios";
import { categoryList } from "../data/categories";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import loader from "../utils/Helper";
import { Box, Grid, TextField, Tooltip } from "@mui/material";
import { useFormik } from "formik";
import moment from "moment";
import Swal from "sweetalert2";
import { MultiSelect } from 'primereact/multiselect';
import { FileUpload } from 'primereact/fileupload';
import { InputSwitch } from 'primereact/inputswitch';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Slide from "@mui/material/Slide";

const GET_QUERY_BY_ID = "/getQuery";
const POST_COMMENT = "/addComment";
const EDITCOMMENT = "/editComment";
const ADD_DOCUMENT = "/addDocument";
const GET_USERS = "/getAllCategoryUsers";
const DELETE_DOCUMENT = "/deleteDocument";
const UPDATE_QUERY = "/updateQuery";
const DELETECOMMENT = "/deleteComment";

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}

const QueryDetails = () => {
  const commentsRef = useRef(null);
  const [showTop, setShowTop] = useState(false);
  const [showBottom, setShowBottom] = useState(false);
  const toast = useRef(null);
  const fileUploadRef = useRef(null);
  const commentInput = useRef();
  const navigate = useNavigate();
  const [comment, setComment] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [isqueryResolved, setisqueryResolved] = useState(false)
  const [editSelectedComment, seteditSelectedComment] = useState();
  const params = useParams();
  const [singleQuery, setSingleQuery] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState(false);
  const [message, setMessage] = useState(false);

  const [assignedToOptions, setAssignedToOptions] = useState([]);

  const [financialYearOptions, setFinancialYearOptions] = useState(null);
  const userData = JSON.parse(localStorage.getItem("user"));
  const initialValues = {
    financialYear: "",
    status: "",
    // priority: "",
    referredBy : "",
    remarks: "",
    categoryListItem: "",
    assignedTo: "",
    consultingTeam : [],
    blockAssessment:false,
    start:null,
    end:null,
    dueDate: null,
    feesDetails: "",
    createdBy: null,
  };

  const handleUpdate = async (values) => {
    try {
      const formdata = {
        id: params.id,
        userId: values.assignedTo || userData.id,
        financialYear: values.financialYear?.id || "",
        status: values.status?.code || "",
        // priority: values.priority?.code || "",
        referredBy : values.referredBy || "",
        remarks: values.remarks || "",
        feesDetails: values.feesDetails || "",
        referredBy: values.referredBy || "",
        UpdatedBy: userData.id,
        dueDate: values.dueDate ? moment.utc(values.dueDate) : null,
        blockAssessment : values.blockAssessment,
        start: values.blockAssessment ? (values.start ? moment.utc(values.start) : null) : null,
        end: values.blockAssessment ? (values.end ? moment.utc(values.end) : null) : null,
        consultingTeam : values.consultingTeam || [],
      };
      loader.isLoading(true);

      const response = await axiosPrivate.post(UPDATE_QUERY, formdata, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.jwtToken}`,
        },
      });
      if (response.status === 200) {
        if (selectedFile.length) {
          handleDocumentUpload();
        } else {
          setOpen(true);
          setSeverity('success');
          setMessage('Query  updated successfully');
          getData();
          loader.isLoading(false);
        }
      }
      else{
        setOpen(true);
        setSeverity('error');
        setMessage(response?.data?.error);
        }
    } catch (err) {
      setOpen(true);
      setSeverity('error');
      setMessage(err.response.data.message);
      loader.isLoading(false);
      console.log("errrr", err);
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleUpdate,
  });

  const fileInputRef = useRef(null);
  const statusOptions = [
    { name: "New", code: "New" },
    { name: "In Progress", code: "In Progress" },
    { name: "Resolved", code: "Resolved" },
  ];

  const filteredStatusOptions =
  userData.isAdmin &&
  formik.values.status?.code === "In Progress"
    ? statusOptions.filter((item) => item.code !== "New")
    : statusOptions;

  // const priorityOptions = [
  //   { name: "High", code: "High" },
  //   { name: "Medium", code: "Medium" },
  //   { name: "Low", code: "Low" },
  // ];

  useEffect(() => {
    if (!financialYearOptions) {
      var currentYear = new Date().getFullYear() + 1;
      const fyOptions = [];
      for (let i = currentYear; i >= 2001; i--) {
        var op = {
          id: parseInt(i) - 1 + "-" + i,
          year: parseInt(i) - 1 + "-" + i,
        };
        fyOptions.push(op);
      }
      setFinancialYearOptions(fyOptions);
    }
    getUsers();
    getData();
  }, []);

  useLayoutEffect(() => {
  if (activeTab === 0 && commentsRef.current) {
    commentsRef.current.scrollTop = commentsRef.current.scrollHeight;
  }
}, [singleQuery?.comments, activeTab]);

useEffect(() => {
  if (activeTab === 1) {
     commentsRef.current.scrollTop = commentsRef.current.scrollHeight;
  }
}, [activeTab]);

  const getData = async () => {
    loader.isLoading(true);

    const response = await axiosPrivate.get(
      `${GET_QUERY_BY_ID}/${params.id}/${userData.id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.jwtToken}`,
        },
      }
    );

    if (response.status === 200) {
      setSingleQuery(response.data);
      loader.isLoading(false);
    } else {
      loader.isLoading(false);
    }
  };

  const handlecommentDelete = (item) => {
    loader.isLoading(true);
    const itemId = item.id;
    const usersId = item.usersId;

    const deleteItem = async () => {
      try {
        const response = await axiosPrivate.delete(
          `${DELETECOMMENT}/${usersId}/${itemId}/${activeTab === 0 ? false : true}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userData.jwtToken}`,
            },
          }
        );
        if (response.status === 200) {
          setOpen(true);
          setSeverity('success');
          setMessage(response?.data?.error);
          getData();
        }
        else{
            setOpen(true);
            setSeverity('error');
            setMessage(response?.data?.error);
        }
      } catch (err) {
        // Handle error here, e.g., show an Error
        console.error("Error deleting user:", err);
        setOpen(true);
        setSeverity('error');
        setMessage(err?.data?.error || "An error occurred while deleting the user");
      } finally {
        loader.isLoading(false);
      }
    };

    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteItem();
      } else {
        loader.isLoading(false);
      }
    });
  };

  const getUsers = async () => {
    try {
      const response = await axiosPrivate.get(`${GET_USERS}/${params.id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userData.jwtToken}`,
        },
      });

      if (response.status === 200) {

        setAssignedToOptions(response.data);
        loader.isLoading(false);
      } else {
        loader.isLoading(false);
        // Handle the error here if needed
      }
    } catch (error) {
      // Handle the error here
      console.error("An error occurred while fetching user data:", error);
      loader.isLoading(false);
    }
  };
  
  const getFilteredOptions = () => {
    if (!assignedToOptions) return [];

    return assignedToOptions.filter((option) => {
      // if you're using optionValue="id"
      return option.id !== formik.values.assignedTo;
    });
  };

  useEffect(() => {
    if (singleQuery) {
      loader.isLoading(true);
      singleQuery?.status=="Resolved"? setisqueryResolved(true): setisqueryResolved(false)
      const categoryValue = singleQuery.categoryId;
      let categoryListItem = categoryList[categoryValue - 1].category;
      formik.setFieldValue("categoryListItem", categoryListItem);
      formik.setFieldValue("createdBy", singleQuery.userName);

      formik.setFieldValue(
        "status",
        statusOptions.filter((a) => a.name == singleQuery.status)[0]
      );
      // formik.setFieldValue(
      //   "priority",
      //   priorityOptions.filter((a) => a.name == singleQuery.priority)[0]
      // );
      formik.setFieldValue(
        "financialYear",
        financialYearOptions.filter(
          (a) => a.year == singleQuery.financialYear
        )[0]
      );
      formik.setFieldValue("feesDetails", singleQuery.feesDetails);
      formik.setFieldValue("referredBy", singleQuery.referredBy);
      formik.setFieldValue("remarks", singleQuery.remarks);
      formik.setFieldValue("blockAssessment", singleQuery.blockAssessment);
      formik.setFieldValue(
        "start",
        singleQuery.start
          ? moment.utc(singleQuery.start).local().toDate()
          : null
      );
      formik.setFieldValue(
        "end",
        singleQuery.end
          ? moment.utc(singleQuery.end).local().toDate()
          : null
      );
      formik.setFieldValue(
        "dueDate",
        singleQuery.dueDate
          ? moment.utc(singleQuery.dueDate).local().toDate()
          : null
      );

      // const selectedUser = assignedToOptions.filter((item) => {
      //  return item.id === singleQuery.assignedUserId;
      // });
      // selectedUser.length &&  formik.setFieldValue("assignedTo", selectedUser[0]);

      const selectedUser = assignedToOptions.find(
        (item) => item.id === singleQuery.assignedUserId
      );

      if (selectedUser) {
        formik.setFieldValue("assignedTo", selectedUser.id); // ✅ store id
      }
      formik.setFieldValue("consultingTeam",singleQuery.consultingTeam || []);
      loader.isLoading(false);
    }
 
  }, [singleQuery,assignedToOptions]);

  let fileDatta = [];
  const getBase64 = (fileData) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onerror = reject;
      reader.onload = () => {
        resolve(reader.result);
        fileDatta.push({
          fileBase64: reader.result,
          fileName: fileData.name,
        });
        setSelectedFile(fileDatta);
      };
    });
  };
  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    try {
      let response = {};
      editSelectedComment
        ? (response = await axiosPrivate.post(
            EDITCOMMENT,
            {
              userId: userData.id,
              queryId: singleQuery.id,
              commentId: editSelectedComment.id,
              comment: comment,
              isInternal : activeTab === 0 ? false : true,
              created: new Date().toString().split(" GMT")[0],
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userData.jwtToken}`,
              },
            }
          ))
        : (response = await axiosPrivate.post(
            POST_COMMENT,
            {
              userId: userData.id,
              queryId: singleQuery.id,
              comment: comment,
              isInternal : activeTab === 0 ? false : true,
              created: new Date().toString().split(" GMT")[0],
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userData.jwtToken}`,
              },
            }
          ));
      if (response.data.status == 200) {
        getData();
        setComment("");
        seteditSelectedComment();
        setOpen(true);
        setSeverity('success');
        setMessage(response.data.error);
      }
    } catch (err) {}
  };

  const handleDocumentUpload = async (e) => {
    try {
      const response = await axiosPrivate.post(
        ADD_DOCUMENT,
        {
          userId: userData.id,
          queryId: singleQuery.id,
          isInternal : false,
          documents: selectedFile,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.jwtToken}`,
          },
        }
      );
      if (response.status === 200) {
        fileInputRef.current.value = null;
        setOpen(true);
        setSeverity('success');
        setMessage("Query  updated successfully");
        getData();
        fileDatta = [];
        setSelectedFile([]);
      }
      loader.isLoading(false);
    } catch (err) {
      console.log(err);
      loader.isLoading(false);
    }
  };

  const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25 MB

  const fileHandle = async (event) => {
    const fileData = [...event.target.files];

    fileData.forEach((singleFile) => {
      if (singleFile.size > MAX_FILE_SIZE) {
        document.getElementById("errorFile").innerHTML = '' + singleFile.name + ': Invalid file size. Maximum upload size is 25 MB.';
        event.target.value = "";
        return;
      }
      document.getElementById("errorFile").innerHTML = '';
      getBase64(singleFile);
    });

    // // Optional: Clear the input so the same file can be selected again
    // event.target.value = "";
  };

  const handleDelete = async (e, userId, documentId, isInternal) => {
    e.preventDefault();
    loader.isLoading(true);
    try {
      const response = await axiosPrivate.delete(
        `${DELETE_DOCUMENT}/${userId}/${documentId}/${isInternal}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userData.jwtToken}`,
          },
        }
      );
      loader.isLoading(false);
      getData();
      setOpen(true);
      setSeverity('success');
      setMessage(response.data.error);
    } catch (err) {}
    loader.isLoading(false);
  };

  const scrollToTop = () => {
  commentsRef.current?.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  };

  const scrollToBottom = () => {
    commentsRef.current?.scrollTo({
      top: commentsRef.current.scrollHeight,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    const el = commentsRef.current;
    if (!el) return;

    setShowTop(el.scrollTop > 50);
    setShowBottom(el.scrollTop + el.clientHeight < el.scrollHeight - 50);
  };

    const handleClose = async () => {
    setOpen(false);
  };


  return (
    <div style={{backgroundColor : "white"}}>
     <Snackbar
    open={open}
    autoHideDuration={5000}
    onClose={handleClose}
    anchorOrigin={{ vertical: "top", horizontal: "right" }}
    TransitionComponent={SlideTransition}
    >
    <Alert
        onClose={handleClose}
        severity= {severity}
        variant="filled"
        sx={{ width: "100%" }}
    >
        {message}
    </Alert>
</Snackbar>
      <Header />

      <Grid
        justifyContent={"space-between"}
        container
        gap={0.2}
        className="query-container"
      >
        <Grid
          md={4.5}
          xs={12}
          style={{ minWidth: "350px" }}
          container
          item
          gap={"2px"}
        >
           {/* Financial year, due date, consultant, status, priority */}
          <form onSubmit={formik.handleSubmit}>
          
         {singleQuery  && <Grid container item spacing={1} gap={1}>
              { (userData.isSuperAdmin || userData.isAdmin) && (
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  bgcolor={"#dee2e6"}
                  paddingBottom={"5px"}
                >
                  <Grid xs={4} >
                    <strong>User</strong>
                  </Grid>
                  <Grid xs={8}>{formik.values.createdBy}</Grid>
                </Grid>
              )}
       
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                >
                  <Grid xs={4} >
                    <strong>Department</strong>
                  </Grid>
                  <Grid xs={8}>{formik.values.categoryListItem}</Grid>
                </Grid>
       
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  bgcolor={"#dee2e6"}
                >
                  <Grid xs={4} >
                    <strong>Financial Year</strong>
                  </Grid>
                  <Grid xs={8}>
                   { isqueryResolved?<>{formik.values.financialYear?.id}</>:<Dropdown
                      value={formik.values.financialYear}
                      options={financialYearOptions}
                      optionLabel="year"
                      placeholder="Select a financial year"
                      style={{ width: "100%" }}
                      name="financialYear"
                      id="financialYear"
                      onChange={formik.handleChange}
                    />}
                  </Grid>
                </Grid>

                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                >
                  <Grid xs={4} >
                    <strong>Block Assessment</strong>
                  </Grid>
                  <Grid xs={8}>
                   { isqueryResolved?<>{formik.values.blockAssessment ? "Yes" : "No"}</>: <InputSwitch
                        inputId="blockAssessment"
                        checked={formik.values.blockAssessment}
                        onChange={(e) =>
                          formik.setFieldValue("blockAssessment", e.value)
                        }
                      />}
                  </Grid>
                </Grid>

                {formik.values.blockAssessment &&
                 <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                  bgcolor={"#dee2e6"}
                >
                <Grid xs={4} >
                    <strong>Start Date</strong>
                  </Grid>
                  <Grid xs={8}>
                  {isqueryResolved?<>{singleQuery?.start&& moment(singleQuery?.start).format('MMMM DD, YYYY')}</>:  <Calendar
                      id="basic"
                      showI
                      dateFormat="MM dd, yy"
                      value={formik.values.start}
                      style={{ width: "100%" }}
                      onChange={formik.handleChange}
                      name="start"
                    />}
                  </Grid>
                </Grid>
                }

                {formik.values.blockAssessment &&
                 <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                >
                  <Grid xs={4} >
                    <strong>End Date</strong>
                  </Grid>
                  <Grid xs={8}>
                  {isqueryResolved?<>{singleQuery?.end&& moment(singleQuery?.end).format('MMMM DD, YYYY')}</>:  <Calendar
                      id="basic"
                      showI
                      dateFormat="MM dd, yy"
                      value={formik.values.end}
                      style={{ width: "100%" }}
                      onChange={formik.handleChange}
                      name="end"
                    />}
                  </Grid>
                </Grid>
                }
            
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                  bgcolor={"#dee2e6"}
                >
                  <Grid xs={4} >
                    <strong>Assessee Name</strong>
                  </Grid>
                  <Grid xs={8}>{singleQuery?.assesseeName}</Grid>
                </Grid>

                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                >
                  <Grid xs={4} >
                    <strong>Referred By</strong>
                  </Grid>

                  <Grid xs={8}>
                    <TextField
                      id="referredBy"
                      name="referredBy"
                      fullWidth
                      multiline
                      rows={4}
                      value={formik.values.referredBy}
                      onChange={formik.handleChange}
                    />
                  </Grid>
                </Grid>
       
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                  bgcolor={"#dee2e6"}
                >
                  <Grid xs={4} >
                    <strong>Subject</strong>
                  </Grid>
                  <Grid xs={8}>{singleQuery?.subject}</Grid>
                </Grid>
             
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                >
                  <Grid xs={4} >
                    <strong>Assigned Consultant</strong>
                  </Grid>
                  <Grid xs={8}>
                    {userData.isSuperAdmin && (
                   <> { isqueryResolved?<>{singleQuery.assignedTo && singleQuery.assignedTo}</>: <Dropdown
                        style={{ width: "100%" }}
                        value={formik.values.assignedTo}
                        filter
                        resetFilterOnHide
                        optionValue="id"
                        optionLabel={(option) => {
                          return (
                            option.referenceName + " (" + option.email + ")"
                          );
                        }}
                        options={assignedToOptions}
                        optionDisabled={(option) => {
                          return !option.isActive;
                        }}
                        // onChange={formik.handleChange}
                        onChange={(e) => {
                                const selectedId = e.value;
                                
                                // 1. Update the 'assignedTo' field normally
                                formik.setFieldValue("assignedTo", selectedId);

                                // 2. Get the current team array
                                const currentTeam = formik.values.consultingTeam || [];

                                // 3. Remove the selected ID from the team array if it exists
                                const updatedTeam = currentTeam.filter((id) => id !== selectedId);

                                // 4. Update the 'consultingTeam' field state
                                formik.setFieldValue("consultingTeam", updatedTeam);
                              }}
                        name="assignedTo"
                        filterPlaceholder="Search Consultant"
                        placeholder="Select a Consultant"
                      />}
                      </>
                    )}
                    {!userData.isSuperAdmin && singleQuery.assignedTo}
                  </Grid>
                </Grid>
                   
                {(userData.isSuperAdmin || userData.isAdmin) &&
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  bgcolor={"#dee2e6"}
                >
                  <Grid xs={4} >
                    <strong>Consulting Team</strong>
                  </Grid>
                  <Grid xs={8}>
                    {userData.isSuperAdmin && (
                      <>
                        {isqueryResolved ? (
                          <>
                            {singleQuery.consultingTeam && singleQuery.consultingTeam}
                          </>
                        ) : (

                          <MultiSelect
                          style={{ width: "100%" }}
                          value={formik.values.consultingTeam || []}
                          options={getFilteredOptions()}
                          optionLabel={(option) => {
                            return (
                              option.referenceName + " (" + option.email + ")"
                            );
                          }}
                          optionValue="id"
                          onChange={(e) => formik.setFieldValue("consultingTeam", e.value || [])}
                          placeholder="Select Consultants"
                          maxSelectedLabels={0} // prevents label rendering
                          selectedItemsLabel={"{0} consultant/s selected"}
                        />
                        )}
                      </>
                    )}

                    {userData.isAdmin &&
                    assignedToOptions
                      .filter((user) =>
                        singleQuery.consultingTeam?.includes(user.id)
                      )
                      .map((user) => (
                        <div key={user.id}>
                          {user.referenceName} ({user.email})
                        </div>
                      ))}
                  </Grid>
                </Grid>
                }
           
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                >
                  <Grid xs={4} >
                    <strong>Due Date</strong>
                  </Grid>
                  <Grid xs={8}>
                  {isqueryResolved?<>{singleQuery?.dueDate&& moment(singleQuery?.dueDate).format('MMMM DD, YYYY')}</>:  <Calendar
                      id="basic"
                      showI
                      dateFormat="MM dd, yy"
                      value={formik.values.dueDate}
                      style={{ width: "100%" }}
                      onChange={formik.handleChange}
                      name="dueDate"
                    />}
                  </Grid>
                </Grid>
          

                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  bgcolor={"#dee2e6"}
                >
                  <Grid xs={4} >
                    <strong>Status</strong>
                  </Grid>
                  <Grid xs={8}>
                    {userData.isAdmin && (
                      isqueryResolved ?<>{formik.values.status?.name}</>:
                      <Dropdown
                        name="status"
                        style={{ width: "100%" }}
                        value={formik.values.status}
                        options={filteredStatusOptions}
                        onChange={formik.handleChange}
                        optionLabel="name"
                        placeholder="Select a Status"
                      />
                    )}
                     {userData.isSuperAdmin && 
                      <Dropdown
                        name="status"
                        style={{ width: "100%" }}
                        value={formik.values.status}
                        options={filteredStatusOptions}
                        onChange={formik.handleChange}
                        optionLabel="name"
                        placeholder="Select a Status"
                      />
                    }
                    {!userData.isSuperAdmin &&
                      !userData.isAdmin &&
                      formik.values.status && <>{formik.values.status.name}</>}
                  </Grid>
                </Grid>
            

              {/* {(userData.isSuperAdmin || userData.isAdmin) && (
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                  bgcolor={"#dee2e6"}
                >
                  <Grid xs={4} >
                    <strong>Priority</strong>
                  </Grid>
                  <Grid xs={8}>
                    {isqueryResolved?<>{formik.values.priority?.name}</>:<Dropdown
                      name="priority"
                      style={{ width: "100%" }}
                      value={formik.values.priority}
                      options={priorityOptions}
                      onChange={formik.handleChange}
                      optionLabel="name"
                      placeholder="Select a Priority"
                    />}
                  </Grid>
                </Grid>
              )} */}

              {(userData.isSuperAdmin || userData.isAdmin) && (
                <Grid
                  display={"flex"}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                >
                  <Grid xs={4} >
                    <strong>Remarks</strong>
                  </Grid>

                  <Grid xs={8}>
                    <input
                      type="text"
                      id="remarks"
                      name={"remarks"}
                      className="form-control"
                      autoComplete="off"
                      onChange={formik.handleChange}
                      value={formik.values.remarks}
                    />
                  </Grid>
                </Grid>
              )}

              {userData.isSuperAdmin && (
                <Grid display={"flex"} container item xs={12}>
                  <Grid xs={4} >
                    <strong>Fees Detail</strong>
                  </Grid>
                  <Grid xs={8}>
                    <TextField
                      id="feesDetails"
                      name="feesDetails"
                      fullWidth
                      multiline
                      rows={6}
                      value={formik.values.feesDetails}
                      onChange={formik.handleChange}
                    />
                  </Grid>
                </Grid>
              )}

              <Grid display={"flex"} container item xs={12} bgcolor={"#dee2e6"}>
                <Grid xs={4} >
                  <strong>Documents</strong>
                </Grid>
                <Grid
                  xs={8}
                  style={{
                    width: "100%",
                    wordWrap: "break-word",
                  }}
                >
                  <div style={{ overflowY: "scroll", height: "100px" }}>
                    {
                      singleQuery?.documents.map((item, index) => {
                        return (
                          <div className="document-link" key={index}>
                            <Tooltip title={item.fileName}>
                            {index + 1}.
                            <a
                              style={{ marginLeft: "2px" }}
                              href={item.fileURL}
                              download
                            >
                              {`${item.fileName.slice(0, 12)}...`}
                            </a>{" "}
                            </Tooltip>
                            {userData.isSuperAdmin && (
                              <i
                                className="pi pi-trash"
                                onClick={(e) =>
                                  handleDelete(e, userData.id, item.id, false)
                                }
                                style={{
                                  cursor: "pointer",
                                  color: "red",
                                  marginLeft: "5px",
                                }}
                              ></i>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </Grid>
              </Grid>

           
                <Grid
                  display={"flex"}
                  gap={1}
                  container
                  item
                  xs={12}
                  paddingBottom={"5px"}
                  justifyContent={"space-between"}
                >
                  <Grid xs={12}>
                    <input
                      type="file"
                      id="file"
                      ref={fileInputRef}
                      onChange={fileHandle}
                      className="form-control form-control"
                      autoComplete="off"
                      multiple
                      style={{ height: "46px" }}
                    />
                 <span id="errorFile" style={{ marginLeft: "10px", color:"red" }}></span>
                  </Grid>
                </Grid>
         

              <Grid
                item
                xs={12}
                marginTop={"20px"}
                display={"flex"}
                justifyContent={"center"}
              >
                <Button
                  label="Submit"
                  type="submit"
                  variant="contained"
                  className="btn p-button-sm  p-component p-button-success btn-h otp-button"
                  style={{ width: "120px", backgroundColor: "#00ADAA" }}
                />

                <Button
                  label="Cancel"
                  variant="contained"
                  color="primary"
                  type="button"
                  className="btn p-button-sm float-right cancelbutton"
                  style={{
                    marginLeft: "10px",
                    width: "120px",
                    height : "58px"
                  }}
                  onClick={() => {
                    setSelectedFile([]);
                    fileInputRef.current.value = null;
                    navigate("/dashboard");
                  }}
                />
              </Grid>
            </Grid>}
          </form>
        </Grid>

        <Grid item md={7.3} xs={12}>
          <div
            style={{
              height: "500px",
              maxHeight: "500px",
              zIndex: 99,
              position: "relative",
            }}
          >

            <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>

            { singleQuery &&  
              <TabPanel header="Comments" >
                <div
                  style={{ position: "relative" }}
                >
                <div
                    onScroll={handleScroll}
                    ref={commentsRef}
                    style={{
                      maxHeight: "700px", // adjust as needed
                      overflowY: "auto",
                      paddingRight: "10px"
                    }}
                  >
                {
                  singleQuery?.comments?.map((item, index) => {
                    return (
                      <div
                        className={`message ${
                          item.usersId === userData.id ? "sent" : "received"
                        }`}
                        key={index}
                        style={{ fontSize: "18px", lineHeight: "20px" }}
                      >
                        <span style={{ fontSize: "15px", fontWeight: "bold" }}>
                          {item.userName}
                        </span>
                       <div style={{ whiteSpace: "pre-wrap" }}>
                          {item.comment}
                        </div>
                        <span style={{ fontSize: "12px" }}>
                          {new Date(item.createdOn).toLocaleString("default", {
                            month: "short",
                          }) +
                            " " +
                            new Date(item.createdOn).getDate() +
                            ", " +
                            new Date(item.createdOn).getFullYear() +
                            " " +
                            new Date(item.createdOn).getHours() +
                            ":" +
                            String(new Date(item.createdOn).getMinutes()).padStart(2, "0")}
                        </span>
                        {userData.isSuperAdmin &&
                          item.usersId === userData.id && (
                            <div style={{ cursor: "pointer" }}>
                              <span>
                                <i
                                  title="Edit "
                                  className="fa-solid fa-pencil px-2"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    seteditSelectedComment(item);
                                    setComment(item.comment);
                                    commentInput.current.focus();
                                  }}
                                ></i>
                              </span>

                              <i
                                title="delete"
                                style={{ cursor: "pointer" }}
                                className="pi pi-trash  px-2 text-danger"
                                onClick={() => handlecommentDelete(item)}
                              ></i>
                            </div>
                          )}
                      </div>
                    );
                  })}
                </div>

                {/* Floating Buttons */}
                <div
                  style={{
                    position: "absolute",
                    right: "15px",
                    bottom: "15px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px", 
                    zIndex: 9999,
                  }}
                >
                  {showTop && (
                    <button onClick={scrollToTop}>
                      <i className="pi pi-angle-up" />
                    </button>
                  )}

                  {showBottom && (
                    <button onClick={scrollToBottom}>
                      <i className="pi pi-angle-down" />
                    </button>
                  )}
                </div>
                </div>
              </TabPanel>
            } 

            {(userData.isSuperAdmin || userData.isAdmin) && 
              <TabPanel header="Comments (For Internal Use Only)" onClick= {scrollToBottom}>
                  <div style={{ position: "relative" }}
                >
                <div
                    onScroll={handleScroll}
                    ref={commentsRef}
                    style={{
                      maxHeight: "700px", // adjust as needed
                      overflowY: "auto",
                      paddingRight: "10px"
                    }}
                  >
                  {
                      singleQuery?.internalComments?.map((item, index) => {
                      return (
                        <div
                          className={`message ${
                            item.usersId === userData.id ? "sent" : "received"
                          }`}
                          key={index}
                          style={{ fontSize: "18px", lineHeight: "20px" }}
                        >
                          <span style={{ fontSize: "15px", fontWeight: "bold" }}>
                            {item.userName}
                          </span>
                          <br />
                          <div style={{ whiteSpace: "pre-wrap" }}>
                          {item.comment}
                          </div>
                          <span style={{ fontSize: "12px" }}>
                            {new Date(item.createdOn).toLocaleString("default", {
                              month: "short",
                            }) +
                              " " +
                              new Date(item.createdOn).getDate() +
                              ", " +
                              new Date(item.createdOn).getFullYear() +
                              " " +
                              new Date(item.createdOn).getHours() +
                              ":" +
                            String(new Date(item.createdOn).getMinutes()).padStart(2, "0")}
                          </span>
                          {userData.isSuperAdmin &&
                            item.usersId === userData.id && (
                              <div style={{ cursor: "pointer" }}>
                                <span>
                                  <i
                                    title="Edit "
                                    className="fa-solid fa-pencil px-2"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      seteditSelectedComment(item);
                                      setComment(item.comment);
                                      commentInput.current.focus();
                                    }}
                                  ></i>
                                </span>

                                <i
                                  title="delete"
                                  style={{ cursor: "pointer" }}
                                  className="pi pi-trash  px-2 text-danger"
                                  onClick={() => handlecommentDelete(item)}
                                ></i>
                              </div>
                            )}
                        </div>
                      );
                    })
                  }
                    {/* Floating Buttons */}
                  <div
                    style={{
                      position: "absolute",
                      right: "15px",
                      bottom: "15px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px", 
                      zIndex: 9999,
                    }}
                  >
                    {showTop && (
                      <button onClick={scrollToTop}>
                        <i className="pi pi-angle-up" />
                      </button>
                    )}

                    {showBottom && (
                      <button onClick={scrollToBottom}>
                        <i className="pi pi-angle-down" />
                      </button>
                    )}
                  </div>
                </div>
                </div>
              </TabPanel>
              }

              {(userData.isSuperAdmin || userData.isAdmin) &&
                <TabPanel header="Documents (For Internal Use Only)">
                   <div className="card">
                      <FileUpload
                          ref={fileUploadRef}
                          name="documents[]"
                          customUpload
                          mode="advanced"
                          multiple
                          maxFileSize={25000000}
                          emptyTemplate={
                              <p className="m-0">
                                  Choose one or multiple files to upload.
                              </p>
                          }
                          uploadHandler={async (e) => {
                              loader.isLoading(true);
                              try {
                                  const req = {
                                      queryId: singleQuery.id,
                                      userId: userData.id,
                                      isInternal: true,
                                      documents: []
                                  };

                                  // Convert all files to Base64
                                  req.documents = await Promise.all(
                                      e.files.map(
                                          (file) =>
                                              new Promise((resolve, reject) => {
                                                  const reader = new FileReader();

                                                  reader.readAsDataURL(file);

                                                  reader.onload = () => {
                                                      const base64 = reader.result.split(",")[1];

                                                      resolve({
                                                          id: 0,
                                                          queryId: singleQuery.id,
                                                          fileBase64: base64,
                                                          fileName: file.name
                                                      });
                                                  };

                                                  reader.onerror = (error) => reject(error);
                                              })
                                      )
                                  );

                                  // Send final request object
                                  const response = await fetch("/api/addDocument", {
                                      method: "POST",
                                      headers: {
                                          "Content-Type": "application/json",
                                          Authorization: `Bearer ${userData.jwtToken}`
                                      },
                                      body: JSON.stringify(req)
                                  });

                                  const data = await response.json();
                                  fileUploadRef.current.clear();
                                  loader.isLoading(false);
                                  getData();
                                  setOpen(true);
                                  setSeverity('success');
                                  setMessage(response.data.error);
                                  
                              } catch (error) {
                                  console.error("Upload failed:", error);
                              }
                          }}
                      />
                    </div>
                    <div className="file-list">
                      {singleQuery?.internalDocuments?.length === 0 && (
                        <p className="text-muted">No documents uploaded</p>
                      )}

                      {singleQuery?.internalDocuments?.map((file, index) => (
                        <div className="file-card" key={index}>
                          
                          <div className="file-left">
                            <i className="pi pi-file file-icon"></i>

                            <div className="file-info">
                              <span className="file-name" title={file.fileName}>
                                {file.fileName}
                              </span>
                            </div>
                          </div>
                         
                          <div className="file-actions">
                             <div className="file-info">
                              <span className="file-name" title={file.fileName}>
                                <b>{file.createdByName} | {file.createdByEmail}</b>
                              </span>
                            </div>
                            <a href={file.fileURL} rel="noreferrer">
                              <i className="pi pi-download action-icon"></i>
                            </a>

                            {userData.isSuperAdmin && (
                              <i
                                className="pi pi-trash action-icon delete"
                                onClick={(e) => handleDelete(e, userData.id, file.id, true)}
                              ></i>
                            )}

                            {userData.isAdmin && file.usersId == userData.id && (
                              <i
                                className="pi pi-trash action-icon delete"
                                onClick={(e) => handleDelete(e, userData.id, file.id, true)}
                              ></i>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                </TabPanel>
              }
            </TabView>
          </div>

        {activeTab != 2 &&
          <form onSubmit={handleCommentSubmit} className="clear-all" style={{paddingTop : "300px"}}>
            <div className="form-group d-flex flex-column-reverse position-relative">
              <textarea
                rows={6}
                ref={commentInput}
                type="text"
                value={comment}
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                id="comment"
                className="form-control"
                autoComplete="off"
              />
              <label htmlFor="comment">Drop your comment here</label>
            </div>
            <div className="btn-area">
              <Button
                label="Cancel"
                onClick={() => {
                  seteditSelectedComment();
                  setComment("");
                }}
                disabled={!comment}
                variant="contained"
                color="primary"
                type="button"
                className="btn p-button-sm  float-right cancelbutton"
                style={{
                  marginLeft: "10px",
                  width: "120px",
                  height : "58px"
                }}
              />
              {editSelectedComment ? (
                <div>
                  <Button
                    type="submit"
                    label="Edit Comment"
                    icon="fa-solid fa-pencil"
                    disabled={!comment}
                    className="p-button-success p-button-sm float-right"
                    badgeClassName="p-badge-danger"
                  />
                </div>
              ) : (
                <Button
                  type="submit"
                  label="Add Comment"
                  disabled={!comment}
                  icon="pi pi-save"
                  className="p-button-success p-button-sm float-right  otp-button"
                  badgeClassName="p-badge-danger"
                   style={{width:"195px"}}
                />
              )}
            </div>
          </form>
          }
        </Grid>
      </Grid>
    </div>
  );
};
export default QueryDetails;
